document.addEventListener('DOMContentLoaded', function() {

  var path = window.location.pathname;

  // Weekly Reset Pack
  if (path.includes('/products/weekly-reset-pack')) {
    var buttons = document.querySelectorAll('[name="add"], .product-form__submit, button[type="submit"]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/pages/weekly-reset';
      });
    });
    var addBtn = document.querySelector('[name="add"]');
    if (addBtn) addBtn.textContent = 'Choose your meals →';
  }

  // DIY 10 Pack
  if (path.includes('/products/diy-10-meal-pack')) {
    var buttons2 = document.querySelectorAll('[name="add"], .product-form__submit, button[type="submit"]');
    buttons2.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/pages/diy-10-meal-pack';
      });
    });
    var addBtn2 = document.querySelector('[name="add"]');
    if (addBtn2) addBtn2.textContent = 'Build your 10 pack →';
  }

});